import type { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';
import { classes } from './utils';

export interface ChipProps extends PropsWithChildren {
  className?: string;
}

export default function Chip({ className, ...props }: ChipProps) {
  return <span className={twMerge(classes.chip, className)} {...props} />;
}
